"use client";
import { GoogleAnalytics } from "@next/third-parties/google";
import { type MouseEvent, useEffect, useState } from "react";

const storageKey = "sensemode-analytics-consent";
type ConsentChoice = "granted" | "denied";

function readStoredChoice(): ConsentChoice | null {
  try {
    const value = window.localStorage.getItem(storageKey);
    return value === "granted" || value === "denied" ? value : null;
  } catch {
    return null;
  }
}

export function ConsentBanner() {
  const [choice, setChoice] = useState<ConsentChoice | null>(null);
  const [isReady, setIsReady] = useState(false);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const restoreChoice = window.setTimeout(() => {
      const storedChoice = readStoredChoice();
      setChoice(storedChoice);
      setVisible(storedChoice === null);
      setIsReady(true);
    }, 0);

    const onOpen = () => setVisible(true);
    window.addEventListener("open-consent", onOpen);

    return () => {
      window.clearTimeout(restoreChoice);
      window.removeEventListener("open-consent", onOpen);
    };
  }, []);
  const choose = (event: MouseEvent<HTMLButtonElement>, value: ConsentChoice) => {
    event.preventDefault();
    event.stopPropagation();
    try {
      window.localStorage.setItem(storageKey, value);
    } catch {
      /* The banner still dismisses if browser storage is unavailable. */
    }
    setChoice(value);
    setVisible(false);
  };
  return (
    <>
      {isReady && choice === "granted" && process.env.NEXT_PUBLIC_GA_ID ? (
        <GoogleAnalytics gaId={process.env.NEXT_PUBLIC_GA_ID} />
      ) : null}
      {visible && (
        <aside className="consent" aria-label="העדפות פרטיות" role="dialog">
          <p>
            נשתמש באנליטיקה רק באישורך, כדי להבין איך משפרים את האתר.{" "}
            <a href="/privacy">למדיניות הפרטיות</a>
          </p>
          <div>
            <button
              type="button"
              className="button button-small"
              onClick={(event) => choose(event, "granted")}
            >
              אישור
            </button>
            <button
              type="button"
              className="button button-quiet"
              onClick={(event) => choose(event, "denied")}
            >
              ללא אנליטיקה
            </button>
          </div>
        </aside>
      )}
    </>
  );
}
